import microuniversoApi from "app/api/microuniversoApi";
import * as parametrosActions from 'app/redux/parametrosSlice'
import store from "app/redux/store/store";

export type ObterParametroInput = {
    fazerCache?: boolean
    usarCacheSePossivel?: boolean
    nome: string
}

export async function obterParametro({fazerCache, usarCacheSePossivel, nome}:ObterParametroInput) : Promise<string> {
    const parametrosRedux = store.getState().parametros

    fazerCache = fazerCache == undefined ? true : fazerCache
    usarCacheSePossivel = usarCacheSePossivel == undefined ? true : usarCacheSePossivel

    const valorParametro = usarCacheSePossivel && nome in parametrosRedux ? parametrosRedux[nome] : await microuniversoApi.Parametro.obter(nome)

    const jaPresenteNoCache = nome in parametrosRedux

    if (fazerCache && !jaPresenteNoCache) {
        store.dispatch(parametrosActions.inserirOuAtualizar({
            Nome: nome, Valor: valorParametro
        }))
    }

    return valorParametro

}